import React, { useEffect, useState, useRef } from 'react'
import ReactDOM from 'react-dom';
import { StackedColumnChart } from 'bizcharts';
import { comma } from 'utils/function'
import { Typography, Box, MenuItem, Select } from '@mui/material';
import {
    ApiFindDropdown

} from 'utils/api/analytics'
import { ApiExportExcel } from 'utils/api/export'

import DataSet from '@antv/data-set';
import {
    G2,
    Chart,
    Tooltip,
    Interval,
    Coord
} from "bizcharts";
import { PieChart } from 'bizcharts';

import moment from 'moment';
import html2canvas from "html2canvas";

import DialogSubmit from 'utils/components/modal-submit'

function ChartCustom({ handleChange, select, title, data_dropdown = [], filter = [], data, color, export_file = [], export_code }) {

    const chartRef = useRef(null);

    const [fileExport, setFileExport] = useState(null)
    const [currentColor, setCurrentColor] = useState(color);
    const [currentData, setCurrentData] = useState(data);
    const [totalData, setTotalData] = useState(0);


    const [typeSubmit, setTypeSubmit] = useState('')
    const [openSubmit, setOpenSubmit] = useState(false)
    const handleOpenSubmit = (status, close) => {
        setOpenSubmit(status)
        if (close) {

            if (['EXCEL'].includes(fileExport)) {

                let status = handleExportExcel(export_code, filter, `excel-${title}`)
                if (status) {
                    // setFilterExport('null')
                    // setFilterDepartment('all')
                    // setFilterHospital('all')
                    // setFilterYear('all')

                }

            } else if (['PNG'].includes(fileExport)) {

                handleExportPNG()
  
                
            }
            setTypeSubmit()
            setFileExport(null)
        }
    }

    const handleColor = (payload) => {

        return currentColor?.[payload.group] || currentColor['default']; // Default color if group-specific color is not found
    };
    useEffect(() => {
        setCurrentColor(color);
    }, [color]);

    useEffect(() => {

        let total = data.reduce((sum, element) => sum + element.value, 0);
        data.forEach(element => {
            element.percent = ((element.value / total)).toFixed(2);
        });
        setTotalData(total)
        setCurrentData(data)
    }, [data])


    useEffect(() => {

        if (fileExport === 'EXCEL') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        } else if (fileExport === 'PNG') {
            handleOpenSubmit(true)
            setTypeSubmit(title)
        }

    }, [fileExport])


    const handleExportPNG = () => {
        if (chartRef.current) {
            html2canvas(chartRef.current).then((canvas) => {
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                // link.download = "chart.png";
                link.download = `${title}-${moment(Date.now()).format('YYYY-MM-DD_HHmmss')}.png`

                link.click();
            });
        }

    };



    const handleExportExcel = async (excel_code, filter, file_name) => {

        let result = await ApiExportExcel({
            "export_code": excel_code,
            "file_name": file_name,
            "filter": filter
        })

        if (result?.status) {

            let { file_url } = result.data

            // Create a hidden anchor element for downloading the file
            const link = document.createElement('a');
            link.href = file_url;
            link.download = ''; // Optional: specify a custom filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            return true

        } else {
            return false

        }





    }

    return (

        <>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}>
                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1, pb: 2 }}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {/* Container for Select elements */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        {/* Age Group Select - Left Aligned */}
                        <Select
                            size="small"
                            value={select || "null"}
                            onChange={(e) => handleChange('ageGroup', e)}
                            sx={{
                                backgroundColor: '#C8EBEB',
                                border: 'none',
                                zIndex: 10,
                                width: '40%',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#C8EBEB',
                                },
                            }}
                        >
                            <MenuItem value="null" disabled>
                                เลือกช่วงอายุ
                            </MenuItem>
                            <MenuItem value={'all'}>ทั้งหมด</MenuItem>
                            {data_dropdown?.map((item, idx) => (
                                <MenuItem key={idx} value={item.i_code}>
                                    {item.i_name}
                                </MenuItem>
                            ))}
                        </Select>

                        {/* Export File Select - Right Aligned */}
                        {export_file && export_file.length > 0 && (
                            <Select
                                size="small"
                                value={fileExport || "null"}
                                onChange={(e) => setFileExport(e.target.value)}
                                sx={{
                                    backgroundColor: '#C8EBEB',
                                    border: 'none',
                                    zIndex: 10,
                                    width: '10%',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#C8EBEB',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#C8EBEB',
                                    },
                                }}
                            >
                                <MenuItem value="null" disabled>
                                    Export
                                </MenuItem>
                                {export_file.map((i, idx) => (
                                    <MenuItem key={idx} value={i}>
                                        {i}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    </Box>
                </Box>










                <Box sx={{ width: '100%', pt: 3 }}>

                    {color ? <Box ref={chartRef}> <PieChart
                        data={currentData}
                        // title={{
                        // 	visible: true,
                        // 	text: title,
                        // }}
                        description={{
                            visible: true,
                            text: '',
                        }}
                        radius={1}
                        angleField='value'
                        colorField='group'
                        tooltip={{
                            showTitle: false,
                            formatter: (v) => ({
                                name: v.group,
                                value: `จำนวน ${comma(v.value)} คน (${((v.value / data.reduce((sum, item) => sum + item.value, 0)) * 100).toFixed(2)}%)`,
                            }),
                            domStyles: {
                                'g2-tooltip': {
                                    fontSize: '14px',
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                    color: '#333',
                                    fontWeight: 'bold',
                                },
                            },
                        }}
                        color={handleColor} // Pass the dynamic color function
                        label={{
                            visible: true,
                            type: 'inner', // แสดง label ข้างในวงกลม
                            autoRotate: false,
                            content: (v) => {
                                // คำนวณเปอร์เซ็นต์
                                const percent = ((v.value / totalData) * 100).toFixed(1); // ปัดเศษทศนิยม 1 ตำแหน่ง
                                return `${v.group}\n${comma(v.value)} (${percent}%)`;
                            },
                            style: {
                                fontSize: 10,
                                fontFamily: "'IBM Plex Sans Thai', sans-serif",
                                fill: "#fff", // เปลี่ยนสี font เป็นขาวเพื่อให้อ่านง่ายขึ้น
                                fontWeight: 'bold',
                                textAlign: 'center', // จัดตำแหน่งข้อความให้อยู่กึ่งกลาง
                            },
                        }}
                        interactions={['element-active']}
                        legend={{
                            position: "bottom",
                            itemName: {
                                style: {
                                    fontSize: 12, // Set font size for the legend text
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the legend text
                                    fill: "#555", // Optional: Set font color for the legend text
                                    fontWeight: 'bold'
                                },
                            },
                        }}
                    /></Box> : null}





                    {/* <PieChart
                        data={data}
                        color={color}
                        title={{
                            visible: true,
                            text: '',
                        }}
                        description={{
                            visible: true,
                            text: '',
                        }}
                        radius={1}
                        angleField='value'
                        colorField='group'
                        // label={{
                        //     visible: true,
                        //     type: 'spider',
                        //     labelHeight: 28,
                        //     content: v => `${v.group}\n${v.value}`
                        // }}
                        // tooltip={{
                        //     showTitle: true, // Optional: Hide the title in the tooltip
                        //     style: {
                        //         fontSize: 12, // Set font size for the pie chart labels
                        //         fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
                        //         fill: "#333", // Optional: Set font color for the labels
                        //         fontWeight: 'bold'
                        //     },
                        //     // itemTpl: "<li>{label}: {total}</li>", // Customize the tooltip content
                        // }}
                        label={{
                            visible: true,
                            type: 'spider',
                            // labelHeight: 28,
                            // labelWidth:200,
                            content: v => `${v.group}\n${comma(v.value)} `,
                            style: {
                                fontSize: 12, // Set font size for the pie chart labels
                                fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
                                fill: "#333", // Optional: Set font color for the labels
                                fontWeight: 'bold'
                            },
                        }}

                        legend={{
                            position: "bottom",
                            itemName: {
                                style: {
                                    fontSize: 12, // Set font size for the legend text
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the legend text
                                    fill: "#555", // Optional: Set font color for the legend text
                                    fontWeight: 'bold'
                                },
                            },
                        }}
                    /> */}





                    {/* <PieChart
                        data={data}
                        // title={{
                        // 	visible: true,
                        // 	text: title,
                        // }}
                        description={{
                            visible: true,
                            text: '',
                        }}
                        radius={0.7}
                        angleField='value'
                        colorField='group'
                        tooltip={{
                            showTitle: false, // Optional: Hide the title in the tooltip
                            style: {
                                fontSize: 12, // Set font size for the pie chart labels
                                fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
                                fill: "#333", // Optional: Set font color for the labels
                                fontWeight: 'bold'
                            },
                            // itemTpl: "<li>{label}: {total}</li>", // Customize the tooltip content
                        }}
                        color={color}
                        label={{
                            visible: true,
                            type: 'spider',
                            // labelHeight: 28,
                            // labelWidth:200,
                            content: v => `${v.group}\n${comma(v.value)} (${v.y}%)`,
                            style: {
                                fontSize: 12, // Set font size for the pie chart labels
                                fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the pie chart labels
                                fill: "#333", // Optional: Set font color for the labels
                                fontWeight: 'bold'
                            },
                        }}
                        legend={{
                            position: "bottom",
                            itemName: {
                                style: {
                                    fontSize: 12, // Set font size for the legend text
                                    fontFamily: "'IBM Plex Sans Thai', sans-serif", // Set font family for the legend text
                                    fill: "#555", // Optional: Set font color for the legend text
                                    fontWeight: 'bold'
                                },
                            },
                        }}
                    /> */}



                </Box>

                <DialogSubmit

                    // loading={loading}
                    title={`${typeSubmit}`}
                    fileType={fileExport}
                    // type={alertType}
                    // message={messageAlert}
                    open={openSubmit}
                    setOpen={setOpenSubmit}
                    handleOpenSubmit={handleOpenSubmit}
                // handleChange={handleAlert}



                />
            </Box>






        </>

    );
}
export default ChartCustom;
